import React from "react";
import AllPages from "./AllPages";
const ModalAllPages = ({
  filePreview,
  showFilePreview,
  setShowFilePreview,
}) => {
  return (
    <div
      id="staticModal"
      data-modal-backdrop="static"
      tabindex="-1"
      aria-hidden="true"
      class={`${
        showFilePreview ? "" : "hidden"
      } bg-gray-100 border-2 border-gray-100  flex flex-col fixed top-[12%] rounded-lg left-[2.5%] right-[2.5%] z-50  w-[95%] h-[85%]  `}
    >
      <div className=" h-[10%] rounded-t-lg text-end bg-white flex flex-row justify-center items-center px-8">
        <h4 className="text-color-text text-lg">{filePreview.name}</h4>

        <button
          onClick={() => {
            setShowFilePreview(!showFilePreview);
          }}
          type="button"
          class="text-color-text bg-transparent hover:bg-gray-200 hover:text-color-text rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
          data-modal-hide="staticModal"
        >
          <svg
            class="w-7 h-7"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
      <div className=" h-[90%] p-4 overflow-x-hidden overflow-y-auto ">
        <div className="h-[100%] w-full">
          <div className="App">
            <div className="all-page-container">
              {filePreview.type === "image/jpeg" ? (
                <img src={URL.createObjectURL(filePreview)} alt="Blob Image" />
              ) : (
                <AllPages pdf={filePreview} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAllPages;
